<template>
    <div
        v-if="showPageBreakPlaceholder"
        class="row border-top py-3 mx-0 page-break-element">
        <div class="col d-flex justify-content-start">
            <pc-button v-if="hasPreviousPage"> Back </pc-button>
        </div>
        <div class="col d-flex justify-content-end">
            <pc-button> Next </pc-button>
        </div>
    </div>
</template>

<script>
    import base from "./_elementBase";
    import { isModuleRegistered } from "SharedStores/util";
    import { EDIT_FORM_NAMESPACE } from "Forms/EditForm/editFormStoreDefinitions";
    import { FORM_TYPES } from "SharedStores/Form/formStore";

    export default {
        extends: base,
        computed: {
            showPageBreakPlaceholder() {
                return isModuleRegistered(EDIT_FORM_NAMESPACE, this.$store.state);
            },
            pageBreakElements() {
                const orderedFormElements = this.$store.getters[FORM_TYPES.getters.orderedFormElements];
                return orderedFormElements
                    ? orderedFormElements.filter((element) => element.ClassName === "PageBreakElement")
                    : [];
            },
            hasPreviousPage() {
                return (
                    this.pageBreakElements.length > 1 && this.pageBreakElements[0].PublicId !== this.element.PublicId
                );
            }
        }
    };
</script>

<style lang="scss" scoped>
    .page-break-element {
        border-bottom: 3px dashed var(--bs-primary);
    }
</style>
